// extracted by mini-css-extract-plugin
module.exports = {"root":"download-app-buttons_root__8ci4B","button":"download-app-buttons_button__mrrSY"};